export default __webpack_public_path__ + "static/media/filter.ecbf5587.svg";